module.exports = __webpack_public_path__ + "img/product-ketang-qt-06.5ed7ff79.png";